import styled from 'styled-components';

export const Button = styled.button`
  position: absolute;
  left: ${({ position }) => (position === 'left' ? 0 : 'auto')};
  right: ${({ position }) => (position === 'right' ? 0 : 'auto')};
  height: 100%;
  width: 72px;
  background-color: #17191B;
  border: none;
  font-size: 30px;
  color: white;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease-in;

  @media (max-width: 768px) {
    width: 40px;
  }
`;

export const Counter = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 18px;
  font-size: 28px;
  background-color: #17191B;
  opacity: 0;
  display: inline-block;
  border-radius: 8px;
  color: white;
  transition: opacity 0.2s ease-in;

  @media (max-width: 768px) {
    padding: 12px;
    font-size: 20px;
  }
`;

export const Container = styled.div`
  height: 580px;
  background-color: ${({ bgColor }) => bgColor};
  position: relative;
  margin-bottom: 44px;

  &:hover {
    ${Counter} {
      opacity: 0.6;
    }
    ${Button} {
      opacity: 0.6;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  @media (max-width: 768px) {
    height: 360px;
  }

  @media (max-width: 560px) {
    height: 240px;
  }
`;

export const List = styled.div`
  display: flex;
  overflow: hidden;
`;

export const Image = styled.div`
  display: block;
  width: 100%;
  height: 580px;

  background-image: ${({ url }) => `url(${url})`};
  background-size: ${({ noPhoto }) => (noPhoto ? '40%' : 'cover')};
  background-repeat: no-repeat;
  background-position: center center;

  flex-shrink: 0;

  @media (max-width: 768px) {
    height: 360px;
  }

  @media (max-width: 560px) {
    height: 240px;
  }
`;

export const Controls = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

`;
